import React from "react";
import NestedMenuCTA from "./NestedMenuCTA";
import NestedMenuLink from "./NestedMenuLink";
import useDynamicMediaQuery from "../../hooks/useDynamicMediaQuery";


const NestedMenu = ({ items = [], ctas = [], level = 1, storeLink, labels = {} }) => {
	if ((!items || !items.length) && (!ctas || !ctas.length)) return null;
	
	// $nav-breakpoint
	const isDesktop = useDynamicMediaQuery(1024 + 180);

	return (
		<div className={`nested-menu level-${level}`}>
			{items.length > 0 && (
				<ul className="nested-menu__items">
					{items.map((link) => (
						<NestedMenuLink link={link} key={link.id} level={level} labels={labels} />
					))}
				</ul>
			)}
			{ctas.length > 0 && (
				<ul className={`nested-menu__ctas`}>
					{ctas.map((cta) => (
						<NestedMenuCTA cta={cta} key={cta.id} />
					))}
				</ul>
			)}
			{level === 1 && isDesktop && (
				<a className="nested-menu__button--store wp-block-button__link" href={storeLink}>{labels.store || "Store"}</a>
			)}
		</div>
	);
};

export default NestedMenu;
